<template>
    <div class="columns is-multiline">
        <div class="column is-full">
            
            <b-field label="Blog visible" message="Controla la visibilidad del blog.">
                <b-switch
                @input="editBasicInfo"
                v-model="info.blogFlag">
                </b-switch>
            </b-field>
       
        </div>
        <div class="column is-full">
            <b-tabs v-model="activeTab">
                <b-tab-item label="Entradas">
                    <EntriesTable
                    :entryListCreate="entryListCreate"
                    :entryEdit="entryEdit"
                    :sections="sections"
                    :addEntryForm="addEntryForm"
                    />
                </b-tab-item>
                <b-tab-item label="Secciones/Categorias">
                    <SectionsTable
                    :sections="sections"
                    :sectionEdit="sectionEdit"
                    :loadingSections="loadingSections"
                    :sectionListCreate="sectionListCreate"
                    @refreshList="fetchSections"
                    />
                    
                </b-tab-item>
            </b-tabs>
        </div>

    </div>
</template>

<script>
import { getHandler, debounce, patchHandler } from '../../../services/http';
import EntriesTable from './components/EntriesTable.vue'
import SectionsTable from './components/SectionsTable.vue'
export default {
    components:{
        EntriesTable,
        SectionsTable
    },
    props:{
        sectionListCreate:{
            type:String,
            default:""
        },
        sectionEdit:{
            type:String,
            default:""
        },
        entryListCreate:{
            type:String,
            default:""
        },
        entryEdit:{
            type:String,
            default:""
        },
        addEntryForm:{
            type:String,
            default:""
        },
        basicInfoUrl:{
            type:String,
            default:""
        },
    },
    data(){
        return{
            activeTab:0,
            loadingSections:false,
            sections:[],
            info:{}
        }
    },
    methods:{
        async fetchSections(){
            this.loadingSections = true
            this.sections = await getHandler(this.sectionListCreate, {error:false, success:false})
            this.loadingSections = false
        },
        
        async fetchDetails(){
            this.loading = true
            let resp = await getHandler(this.basicInfoUrl, {error:false, success:false})
            this.info = resp
            this.loading = false
        },

        editBasicInfo: debounce(
                async function (){
                var msg = {
                    resource:'notify'
                }
                var resp = await patchHandler(this.basicInfoUrl, this.info, {error:msg, success:msg})
                this.fetchDetails()
            },
            700
        ),
        
    },
    created(){
        this.fetchSections()
        this.fetchDetails()
    }
}
</script>